import React, { useEffect, useState } from "react";
import ActorCard from "./ActorCard";
import "./actors.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import Alert from "../common/Alert";
import InvitationPopUp from "./InvitationPopUp"; 
import useTalentSelection from "../../hooks/useTalentSelection";

const ActorsSelectingList = ({ actors }) => {

    const userRole = localStorage.getItem("role");
    const producerId = localStorage.getItem("userId");

    const [isModalOpen, setIsModalOpen] = useState(false);
    const { selectedIds, handleSelectionChange, resetSelection } = useTalentSelection(); // Use the custom hook

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [alertSeverity, setAlertSeverity] = useState("success"); // 'success', 'error', 'warning', 'info'
    const [alertMessage, setAlertMessage] = useState("");

    const triggerAlert = (message, severity) => {
        setAlertMessage(message);
        setAlertSeverity(severity);
        setOpenSnackbar(true);
    };

    const handleSubmit = () => {
        if (!selectedIds.length) { // Use selectedIds from the hook
            triggerAlert("Please select Actors to send invitation.", "error");
        } else {
            openModal();
        }
    };

    const openModal = () => {
        setIsModalOpen(true);
    };

    const resetAndCloseModal = () => { // Renamed to avoid conflict with hook's resetSelection
        resetSelection(); // Call resetSelection from the hook
        closeModal();
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

return (
    <div>

    { (userRole === "producer" || userRole === "director") && (
        <div className="button-container">
        <FontAwesomeIcon icon={faEnvelope} className="envelop" />
            <button onClick={handleSubmit} >
            Send Invitation
            </button>
        </div>
    )
    }

    <div className="actorList">
        {actors.map((actor) => (
        <ActorCard
            key={actor.user.id}
            actor={actor}
            userRole={userRole}
            selectedActorsIds={selectedIds} // Pass selectedIds from the hook
            handleActorSelectionChange={handleSelectionChange} // Pass handleSelectionChange from the hook
        />
        ))}
    </div>
    <Alert
        openSnackbar={openSnackbar}
        alertSeverity={alertSeverity}
        setOpenSnackbar={setOpenSnackbar}
        alertMessage={alertMessage}
      />

      <InvitationPopUp
        closeModal={closeModal}
        isModalOpen={isModalOpen}
        producerId={producerId}
        selectedActorsIds={selectedIds} // Pass selectedIds from the hook
        resetSelection={resetAndCloseModal} // Pass the new resetAndCloseModal function
      />
    </div>
);
};

export default ActorsSelectingList;
